import { Box, Button, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getDateformatUsingSeconds, getFixedValue } from '../../utils/constant';
import postHeart from '../../assets/images/icons/postHeart.svg'
import openEye from '../../assets/images/icons/openEye.svg'
import postComment from '../../assets/images/icons/postComment.svg'
import { useSelector } from 'react-redux';
const Posts = ({ details, flag }) => {
    const {isScreenZoomed} = useSelector(state=>state.commonSlice);
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 4,
            slidesToSlide: isScreenZoomed ? 4 : 5,
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: isScreenZoomed ? 4 : 5,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };
    const [tab, setTab] = useState("topMostPost")
    const Poststats = ({ img, value }) => {
        return (
            <Stack direction={"row"} alignItems={"center"} gap={1}>
                <img src={img} alt={img} style={{ filter: 'brightness(0) invert(1)', height: '16px', width: '16px' }} />
                <Typography fontSize={12} fontWeight={500} color={'white'}>{value}</Typography>
            </Stack>
        )
    }
    return (
        <>
            <Stack direction="row" mt={3} mb={3} gap={4} justifyContent={"space-between"} alignContent={"center"} marginTop={'40px'}>
                <Stack direction={"row"} gap={2} alignItems={"center"} >
                    <Typography fontSize={16} fontWeight={400} color={"#726C6C"}>CONTENT</Typography>
                    {details?.content?.topMostPost?.length > 0 && flag && <a href={`/`} onClick={(e) => {
                        e.preventDefault();
                        window.open(`/creator-content/${details.handleRecordId}/${details.userId}`, "_blank")
                    }} style={{ fontSize: 16, fontWeight: 400, color: '#7209B7', textDecoration: "none" }}>View All...</a>}
                </Stack>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', border: '1px solid #EEE', padding: '4px', borderRadius: '4px' }}>
                    <Stack direction="row" spacing={1} border={'0px solid #F0F0F0'}>
                        {console.log(tab, 'tabtab')}
                        <Button onClick={() => setTab("topMostPost")} sx={{
                            color: tab === "topMostPost" ? "white" : 'black', background: tab === "topMostPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                        }} ><Typography fontSize={12} fontWeight={500} color={tab === "topMostPost" ? "white" : 'black'} background={tab === "topMostPost" ? "var(--color-blue)" : 'white'}>Top Posts</Typography></Button>
                        <Button onClick={() => setTab("topRecentPost")} sx={{
                            color: tab === "topRecentPost" ? "white" : 'black', background: tab === "topRecentPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                        }}><Typography fontSize={12} fontWeight={500} color={tab === "topRecentPost" ? "white" : 'black'} background={tab === "topRecentPost" ? "var(--color-blue)" : 'white'}>Recent Posts</Typography></Button>
                    </Stack>
                </Box>
            </Stack>
            {details?.content?.[tab]?.length > 0 ? <Carousel responsive={responsive} itemClass="carousel-item-padding-40-px">
                {
                    details?.content?.[tab]?.map((v) => (
                        <Box onClick={() => {
                            if (v.shortcode) {
                                window.open(v.shortcode)
                            } else {
                                return
                            }
                        }}
                            key={v.id} sx={{ height: '341px', width: '280px', borderRadius: '4px', border: '0px solid red', overflow: 'hidden' }}>
                            <img src={v?.thumbnailSrc} alt={v?.thumbnailSrc} style={{ width: '100%', height: '90%', objectFit: 'cover' }} />
                            <Stack sx={{ height: '10%', width: '100%', background: 'black', borderRadius: '0 0 4px 4px', padding: '8px' }} justifyContent={"space-between"} alignItems={"center"} direction={"row"}>
                                <Stack direction={"row"} gap={1} justifyContent={"flex-start"} alignItems={"center"}>
                                    <Poststats img={postHeart} value={getFixedValue(v.previewLikeCount)} />
                                    <Poststats img={openEye} value={getFixedValue(v.viewCount)} />
                                    <Poststats img={postComment} value={getFixedValue(v.commentCount)} />
                                </Stack>
                                <Typography fontSize={12} fontWeight={500} color={"white"}>{getDateformatUsingSeconds(v.timestamp)}</Typography>
                            </Stack>
                        </Box>
                    ))
                }
            </Carousel> : <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-3 col-sm-4 col-6">
                <div className="brandBlocks brandBlImg">No Data Found</div>
            </div>}
        </>
    );
};
export default Posts;
